/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Guest_Empty_DirectoryInputs */

const vi_meeting_guest_empty_directory = /** @type {(inputs: Meeting_Guest_Empty_DirectoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Danh bạ chưa có ai. Khách mời được thêm ngay lúc xếp lịch họp.`)
};

/**

* @param {Meeting_Guest_Empty_DirectoryInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const meeting_guest_empty_directory = /** @type {((inputs?: Meeting_Guest_Empty_DirectoryInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Guest_Empty_DirectoryInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_meeting_guest_empty_directory(inputs)
});